<template>
  <div class="dialog-remote-upgrade-wrapper">
    <!--远程升级弹窗-->
    <el-dialog title="远程升级" :visible="visible" @close="onDialogClose">
      <el-form label-position="top" ref="upgradeForm" :rules="upgradeRules" :model="upgradeForm">

        <el-form-item label="设备类型" prop="dev">
          <el-radio v-model="upgradeForm.dev" label="android">安卓</el-radio>
          <el-radio v-model="upgradeForm.dev" label="dtu">DTU</el-radio>
          <el-radio v-model="upgradeForm.dev" label="mcu">MCU</el-radio>
        </el-form-item>

        <el-form-item label="升级方式" prop="type">
          <el-radio v-model="upgradeForm.type" label="http">HTTP</el-radio>
          <el-radio v-model="upgradeForm.type" label="tcp">TCP</el-radio>
        </el-form-item>

        <el-form-item label="是否初始化" prop="init">
          <el-radio v-model="upgradeForm.init" label="1">是</el-radio>
          <el-radio v-model="upgradeForm.init" label="0">否</el-radio>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onUpgradeSubmit">确定</el-button>
          <el-button @click="onUpgradeCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DialogRemoteUpgrade',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    upgradeDev: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      upgradeRules: {
        dev: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择升级方式', trigger: 'change' }
        ],
        init: [
          { required: true, message: '请选择是否初始化 ', trigger: 'change' }
        ]
      },
      upgradeForm: {
        dev: 'android',
        init: '0',
        type: 'http'
      }
    }
  },
  methods: {
    ...mapActions('device', [
      'remoteUpgrade'
    ]),

    onDialogClose () {
      this.$emit('update:visible', false)
    },
    async onUpgradeSubmit () {
      this.$emit('update:visible', false)

      try {
        await this.remoteUpgrade({
          sn: this.upgradeDev.sn,
          dev: this.upgradeForm.dev,
          init: this.upgradeForm.init,
          type: this.upgradeForm.type
        })
        this.$message({
          type: 'success',
          message: '远程升级推送成功'
        })
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '远程升级推送失败'
        })
      }
    },
    onUpgradeCancel () {
      this.$emit('update:visible', false)
      this.$refs['upgradeForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.dialog-remote-upgrade-wrapper {

  .dialog-remote-upgrade {
    display: flex;
    justify-content: space-around;
    align-items: center;

    div {
      width: 150px;
      height: 150px;
      line-height: 150px;
      text-align: center;
      color: #FFFFFF;
      font-size: 1.4rem;
      font-weight: bold;
      border-radius: 5px;
      background: $primaryColor;
      cursor: pointer;
      box-shadow: 0 3px 10px 3px #a2a2a2;
      transition: all .2s;

      &:hover {
        box-shadow: 0 3px 10px 5px #a2a2a2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dev/DialogRemoteUpgrade.vue